export const BTN_GET_APP_LINK = 'btn_get_app_link'
export const REDEEM_COUPON = 'btn_redeem_coupon'
export const COUPONS_LIST_SCREEN = 'coupons_list_screen'
export const R2D2_EKIND_HOME = 'new_home_wrapper_screen'
export const PRODUCT_BUTTON_EXPERIMENT_NAME = 'wrapper_v3'
